import React, { useEffect, useState, useMemo } from "react";
import ColumnComponent from "../../ColumnComponent/ColumnComponent";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import OrderBox from "../../OrderBoxV2/OrderBoxV2";
import PerfectScrollbar from "react-perfect-scrollbar";
import OrderDriverBox from "../../OrderDriverBox/OrderDriverBox";
import { filterDeliveredOrders } from "../../../../utils/deliveredOrdersUtils";

type Props = {
  isAdmin?: boolean;
};
const DriverArchivedColumn = ({ isAdmin }: Props) => {
  const orderState = useSelector((state: RootState) => state.order);
  const deliveredLastWeek = useMemo(
    () => filterDeliveredOrders(orderState.finishedOrders, 7),
    [orderState.finishedOrders],
  );
  const loading = isAdmin ? orderState.loadingTransactions : orderState.loadingOrders;
  const failed = isAdmin ? orderState.transactionsFailed : orderState.ordersFailed;
  const [orders, setOrders] = useState<any>(<div>Waiting...</div>);
  useEffect(() => {
    if (!loading) {
      if (failed) {
        //     tODO ovde prikaz ako se desila greska prilikom ucitavanja porudzbina
      } else {
        const sortedOrders = [...deliveredLastWeek].sort(
          (a: any, b: any) => b.id - a.id,
        );
        setOrders(
          sortedOrders.length > 0 &&
            sortedOrders.map((order: any, index: number) => {
              return (
                <OrderDriverBox
                  archived={true}
                  key={index}
                  order={order}
                  isAdmin={isAdmin}
                />
              );
            }),
        );
      }
    }
  }, [deliveredLastWeek, loading]);

  return (
    <ColumnComponent
      leftSideLabel="Realizovane"
      leftSideNumber={deliveredLastWeek.length.toString()}
      bodyStyle={{ backgroundColor: "transparent", border: "none" }}
      style={{ flex: "4" }}
    >
      <PerfectScrollbar style={{ padding: "4px" }}>{orders}</PerfectScrollbar>
    </ColumnComponent>
  );
};

export default DriverArchivedColumn;
